import { render, staticRenderFns } from "./JoinLinks.vue?vue&type=template&id=fd98bd4c&"
import script from "./JoinLinks.vue?vue&type=script&lang=js&"
export * from "./JoinLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports